import Button, { type ButtonProps } from '@creator/ui/components/Button/ButtonV2';
import { mergeProps } from '@creator/ui/utils/merge-props/merge-props';
import { cn } from '@creator/ui/utils/ui';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface ApproveOrDeleteButtonsProps {
    className?: string;
    approveButtonProps?: ButtonProps;
    deleteButtonProps?: ButtonProps;
}

const ApproveOrDeleteButtons: FC<ApproveOrDeleteButtonsProps> = props => {
    const { className } = props;
    const { t } = useTranslation();

    function renderApproveButton() {
        const { approveButtonProps = {} } = props;

        const _props = mergeProps(
            {
                color: 'primary',
                size: 'xs',
                className: 'w-[100px]',
            },
            approveButtonProps
        );

        return <Button {..._props}>{t('approveOrDeleteButtons.approveButton')}</Button>;
    }

    function renderDeleteButton() {
        const { deleteButtonProps = {} } = props;

        const _props = mergeProps(
            {
                color: 'base',
                size: 'xs',
                className: 'w-[100px]',
            },
            deleteButtonProps
        );

        return <Button {..._props}>{t('approveOrDeleteButtons.deleteButton')}</Button>;
    }

    return (
        <div className={cn('flex space-x-4', className)}>
            {renderApproveButton()}
            {renderDeleteButton()}
        </div>
    );
};

export default ApproveOrDeleteButtons;
